import React, { createContext, useContext, useState } from "react";

type CopilotContextValue = {
  open: boolean;
  openCopilot: () => void;
  closeCopilot: () => void;
  toggleCopilot: () => void;
};

const CopilotContext = createContext<CopilotContextValue | undefined>(undefined);

export function CopilotProvider({ children }: React.PropsWithChildren) {
  const [open, setOpen] = useState(false);

  const openCopilot = () => setOpen(true);
  const closeCopilot = () => setOpen(false);
  const toggleCopilot = () => setOpen((previous) => !previous);

  return (
    <CopilotContext.Provider value={{ open, openCopilot, closeCopilot, toggleCopilot }}>
      {children}
    </CopilotContext.Provider>
  );
}

export function useCopilot(): CopilotContextValue {
  const value = useContext(CopilotContext);
  if (!value) {
    throw new Error("useCopilot must be used within a CopilotProvider");
  }
  return value;
}
